import { QueryClientProvider, type QueryClient } from '@tanstack/react-query';
import { MotionConfig } from 'motion/react';
import { useState } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router';
import { useApplyTheme } from '../features/theme/hooks/use-theme-toggle';
import { createQueryClient } from './query-client';
import { appRoutes } from './routes';

const router = createBrowserRouter(appRoutes);

export function App() {
  const [queryClient] = useState<QueryClient>(createQueryClient);
  useApplyTheme();

  return (
    <QueryClientProvider client={queryClient}>
      <MotionConfig reducedMotion="user">
        <RouterProvider router={router} />
      </MotionConfig>
    </QueryClientProvider>
  );
}
